import { i18next } from '@frontend/i18n';
import { ChipProps } from '@frontend/design-system';

export const getAppointmentOutcomeColor = (appointmentOutcome: string): ChipProps['variant'] => {
  switch (appointmentOutcome) {
    case 'Accepted':
      return 'success';
    case 'Pending':
      return 'disabled';
    case 'Confirmed':
      return 'eggplant';
    case 'Cancelled':
      return 'critical';
    case 'Rejected':
      return 'critical';
    case 'Completed':
      return 'primary';
    case 'Messaged':
      return 'seaweed';
    case 'Called':
      return 'seaweed';
    case 'Dismissed':
      return 'tangerine';
    case 'Done':
      return 'neutral';
    default:
      return 'disabled';
  }
};

export const getAppointmentOutcomeText = (appointmentOutcome: string) => {
  switch (appointmentOutcome) {
    case 'Accepted':
      return i18next.t('Accepted', { ns: 'schedule-request-history' });
    case 'Pending':
      return i18next.t('Pending', { ns: 'schedule-request-history' });
    case 'Confirmed':
      return i18next.t('Confirmed', { ns: 'schedule-request-history' });
    case 'Cancelled':
      return i18next.t('Cancelled', { ns: 'schedule-request-history' });
    case 'Rejected':
      return i18next.t('Rejected', { ns: 'schedule-request-history' });
    case 'Completed':
      return i18next.t('Completed', { ns: 'schedule-request-history' });
    case 'Messaged':
    case 'Called':
      return i18next.t('Contact Attempted', { ns: 'schedule-request-history' });
    case 'Dismissed':
      return i18next.t('Dismissed', { ns: 'schedule-request-history' });
    case 'Done':
      return i18next.t('Done', { ns: 'schedule-request-history' });
    default:
      return appointmentOutcome;
  }
};
